"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var DialogTheme = function DialogTheme(colors, breakpoints) {
  var _container, _close;

  return {
    defaultProps: {
      PaperProps: {
        elevation: 3
      }
    },
    styleOverrides: {
      container: (_container = {}, (0, _defineProperty2["default"])(_container, breakpoints.down('xs'), {
        alignItems: 'flex-start'
      }), (0, _defineProperty2["default"])(_container, '&$scrollPaper', {
        overflowY: 'auto'
      }), _container),
      paper: (0, _defineProperty2["default"])({
        position: 'relative',
        overflowY: 'initial'
      }, breakpoints.down('xs'), {
        marginLeft: 0,
        marginRight: 0
      }),
      paperScrollPaper: (0, _defineProperty2["default"])({}, breakpoints.down('xs'), {
        maxHeight: '100%'
      }),
      close: (_close = {
        position: 'absolute',
        top: 16,
        right: 16,
        color: colors.ultramarine
      }, (0, _defineProperty2["default"])(_close, breakpoints.up('sm'), {
        top: 15,
        right: 20
      }), (0, _defineProperty2["default"])(_close, breakpoints.up('md'), {
        top: 0,
        right: 'auto',
        left: 'calc(100% + 16px)',
        width: 40,
        height: 40,
        backgroundColor: 'white',
        borderRadius: 8
      }), _close)
    }
  };
};

var _default = DialogTheme;
exports["default"] = _default;